import { render, staticRenderFns } from "./SupplierDataTable.vue?vue&type=template&id=638d448e"
import script from "./SupplierDataTable.vue?vue&type=script&lang=js"
export * from "./SupplierDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports